import { AsyncUIAvatar } from 'svh-workspace-ui-lib/code-splitting/public';
import ContactInformation from './ContactInformation';
import FloatingRemoveButton from '../../crm-sidebar-cards/components/FloatingRemoveButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import IdentifyContactWarning from './IdentifyContactWarning';
import NewFeatureTourStep from '../../new-feature-onboarding/components/NewFeatureTourStep';
import { isKnownContact as isKnownContactOperator } from '../../contacts/operators/isKnownContact';
import { getEmail, getCanonicalVid } from 'conversations-inbox-lib/contacts/public/operators';
import { getFormattedContactName } from '../../contacts/operators/contactGetters';
import { CRM_CONTACT_CARD } from '../../new-feature-onboarding/constants/OnboardingConstants';
import { ASSOCIATE_CONTACT_MARKER, DISASSOCIATE_CONTACT_MARKER } from '../../performance-metrics/constants/performanceConstants';
import { recordDuration } from '../../performance-metrics/gatherPerformanceMetrics';
import OnboardingTour from '../../new-feature-onboarding/components/OnboardingTour';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ConditionalWrapper = ({
  wrapper,
  condition,
  children
}) => condition ? wrapper(children) : children;
const ContactHighlightSection = ({
  contact,
  openAssociateModal,
  openDisassociateModal,
  shouldDisplayContactWarning,
  shouldDisplayIdentifyBadge
}) => {
  const isKnownContact = isKnownContactOperator(contact);
  const vid = getCanonicalVid(contact);
  const email = getEmail(contact);
  const name = isKnownContact ? getFormattedContactName(contact) : undefined;
  if (isKnownContact) {
    recordDuration(ASSOCIATE_CONTACT_MARKER);
  } else {
    recordDuration(DISASSOCIATE_CONTACT_MARKER);
  }
  return /*#__PURE__*/_jsx(OnboardingTour, {
    shouldInitialize: false,
    children: /*#__PURE__*/_jsxs(View, {
      paddingBlockStart: "1100",
      paddingInlineStart: "600",
      paddingInlineEnd: "600",
      as: "div",
      children: [/*#__PURE__*/_jsx("div", {
        children: shouldDisplayContactWarning && /*#__PURE__*/_jsx(IdentifyContactWarning, {
          vid: vid
        })
      }), /*#__PURE__*/_jsx(NewFeatureTourStep, {
        stepKey: CRM_CONTACT_CARD,
        header: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-inbox-ui.new-feature-onboarding.crmSidebar.contactHighlightCard.header"
        }),
        body: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-inbox-ui.new-feature-onboarding.crmSidebar.contactHighlightCard.body"
        }),
        placement: "left",
        children: /*#__PURE__*/_jsx(ConditionalWrapper, {
          condition: isKnownContact,
          wrapper: children => /*#__PURE__*/_jsx(FloatingRemoveButton, {
            onClick: openDisassociateModal,
            tooltipPlacement: "bottom left",
            title: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "conversations-inbox-ui.crm-integration.disassociatePrompt.disassociateContact"
            }),
            children: children
          }),
          children: /*#__PURE__*/_jsxs(Flex, {
            alignItems: "center",
            children: [/*#__PURE__*/_jsx(Flex, {
              marginInlineEnd: "300",
              children: /*#__PURE__*/_jsx(AsyncUIAvatar, {
                size: "md",
                type: "contact",
                vid: vid || undefined,
                email: email,
                displayName: name,
                showTooltip: true,
                childMarginInlineStart: "300",
                childTruncateLength: 200
              })
            }), /*#__PURE__*/_jsx(ContactInformation, {
              name: name,
              openAssociateModal: openAssociateModal,
              shouldDisplayIdentifyBadge: shouldDisplayIdentifyBadge,
              isKnownContact: isKnownContact
            })]
          })
        })
      })]
    })
  });
};
ContactHighlightSection.displayName = 'ContactHighlightSection';
export default ContactHighlightSection;